import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.pre`
  ${tw`text-xs max-w-full overflow-auto text-left`};
  max-height: 100vh;
  overflow: auto;
`
